import { Button, Input, notification, Spin } from 'antd';
import { useState } from 'react';
import { Dynamics } from '@/services/dynamics/dynamics';
import { entityFields } from '@/components/CallPanel/config';
import { LoadingOutlined } from '@ant-design/icons';
import {
  getFieldValidationConfigForObject,
  validateFormData,
  getErrorIfNotValid,
} from './FormValidationConfig';
import './Forms.scss';

const antIcon = <LoadingOutlined spin />;
const FIELD_VALIDATION_CONFIG = getFieldValidationConfigForObject('Account');
interface IProps {
  setUnsavedFormData: (data: any) => void;
  data: any;
  prefilledPhone: string;
}

export const NewAccountForm = ({
  setUnsavedFormData,
  data,
  prefilledPhone,
}: IProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [notificationApi, contextHolder] = notification.useNotification();
  const [formData, setFormData] = useState(
    data?.Account || {
      accountName: '',
      phone: prefilledPhone,
    },
  );

  const [formDataErrors, setFormDataErrors] = useState({
    accountName: '',
    phone: '',
  });

  const changeValue = (item: string) => {
    return (e) => {
      setUnsavedFormData({
        Account: {
          ...formData,
          [item]: e.target.value,
        },
      });
      setFormData({
        ...formData,
        [item]: e.target.value,
      });
      setFormDataErrors({
        ...formDataErrors,
        [item]: getErrorIfNotValid(
          e.target.value,
          FIELD_VALIDATION_CONFIG[item],
        ),
      });
    };
  };

  const validate = () => {
    const errors = {
      accountName: '',
      phone: '',
    };

    const isOk = validateFormData(formData, errors, FIELD_VALIDATION_CONFIG);
    setFormDataErrors(errors);
    return isOk;
  };

  const showRes = async () => {
    const isValid = validate();
    if (isValid) {
      const payload = {
        name: formData.accountName?.trim(),
        telephone1: formData.phone?.trim(),
      };
      await Dynamics.saveNewEntity('account', payload);
      setIsLoading(false);
      setFormData({
        accountName: '',
        phone: '',
      });
      setUnsavedFormData(null);
      setTimeout(() => {
        notificationApi.success({
          message: 'Account successfully created',
          placement: 'bottomRight',
          duration: 3,
          className: 'notifications',
        });
      }, 0);
    }
  };
  return isLoading ? (
    <Spin className="spinner" indicator={antIcon} />
  ) : (
    <div>
      {contextHolder}
      <p className="heading">Fill in the form</p>
      <div className="form-container">
        {Object.keys(entityFields.account).map((item) => {
          return (
            <div key={item} className="line">
              {entityFields.account[item]}
              <Input
                placeholder={entityFields.account[item]}
                value={formData[item]}
                onChange={changeValue(item)}
                status={formDataErrors[item] ? 'error' : ''}
              />
              {formDataErrors[item] ? (
                <div className="form-error">{formDataErrors[item]}</div>
              ) : (
                <></>
              )}
            </div>
          );
        })}
      </div>
      <div className="button-block">
        <Button onClick={showRes} data-testid="create-account">
          Submit
        </Button>
      </div>
    </div>
  );
};
